import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'Paquete de Actividades Prácticas',
  value: '15',
  desc: 'Un paquete completo de actividades listas para el aula con instrucciones detalladas, materiales necesarios y objetivos pedagógicos claros. Diseñadas para el contexto latinoamericano: sin equipamiento costoso, sin laboratorio de alta tecnología, sin presupuesto imposible.',
  benefit: 'Cada actividad conecta la teoría con la vida real del estudiante. Tus alumnos no leen sobre el cuerpo humano. Lo experimentan.'
}, {
  id: '02',
  title: 'Paquete de Evaluaciones 360 con Clave de Respuestas',
  value: '15',
  desc: 'Evaluaciones completas por unidad y evaluaciones integradoras con clave de corrección incluida. Formato mixto: verdadero y falso con justificación, opción múltiple, respuesta corta y casos clínicos. Listas para imprimir o proyectar.',
  benefit: 'Nunca más construyas un examen desde cero bajo presión a las 11 de la noche.'
}, {
  id: '03',
  title: 'Guía de Proyectos Anuales y Ferias Científicas',
  value: '10',
  desc: 'Estructuras completas de proyectos de salud para todo el año lectivo: desde la Feria de la Salud hasta el Manual de Primeros Auxilios del Grado, pasando por la Campaña de Salud Comunitaria Digital. Cada proyecto incluye cronograma de ejecución, guías para los estudiantes y rúbricas de evaluación.',
  benefit: 'Nunca más le respondás a tu directivo que "todavía no sé qué proyecto voy a hacer este año".'
}, {
  id: '04',
  title: 'Glosario Técnico Superior para Docente y Alumno',
  value: '9',
  desc: 'Más de 350 términos técnicos del campo de las ciencias de la salud con dos niveles de definición: una versión técnica y completa para el docente y una versión clara y sin jerga para el alumno. Organizado alfabéticamente y diseñado para consulta permanente durante todo el año.',
  benefit: 'Nunca más un silencio incómodo frente a un término que no recordás cómo explicar con precisión.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-cream border-y border-green-emerald/15" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <p className="text-green-emerald font-bold tracking-widest uppercase mb-2" data-id="element-18">
            Incluidos sin costo extra
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-green-dark" data-id="element-19">
            🎁 Los 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream-card border border-green-emerald/20 rounded-2xl p-8 relative group hover:border-green-emerald/50 transition-colors shadow-sm" data-id="element-21">
              <div className="absolute top-0 right-0 bg-green-veryLight text-green-emerald px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-green-emerald/20" data-id="element-22">
                BONO {bonus.id}
              </div>

              <div className="w-12 h-12 bg-green-veryLight rounded-full flex items-center justify-center text-green-emerald mb-6" data-id="element-23">
                <Gift size={24} data-id="element-24" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16 text-green-dark" data-id="element-25">
                {bonus.title}
              </h3>

              <div className="inline-block bg-green-veryLight px-3 py-1 rounded mb-4" data-id="element-26">
                <span className="text-ink-muted text-sm" data-id="element-27">
                  Valor real:{' '}
                  <span className="line-through" data-id="element-28">USD {bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-29">→ GRATIS</span>
              </div>

              <p className="text-ink-muted text-sm mb-6 leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>

              <p className="text-green-emerald text-sm italic font-medium" data-id="element-31">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-green-veryLight border border-green-emerald/30 rounded-2xl p-8 text-center max-w-2xl mx-auto shadow-sm" data-id="element-32">
          <p className="text-ink-muted mb-2" data-id="element-33">Valor total de los 4 bonos</p>
          <p className="text-2xl text-ink-muted line-through mb-4" data-id="element-34">USD 49,00</p>
          <p className="text-lg text-ink mb-2" data-id="element-35">Tu precio hoy</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-36">
            🎁 GRATIS
          </p>
          <p className="text-sm text-green-emerald" data-id="element-37">
            Solo incluidos en esta oferta.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" />
      </div>
    </section>;
}